import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import cx from 'classnames'
import TitledContent from 'components/TitledContent'
import Tooltip from 'components/Tooltip'
import Income from 'components/Income'

import { formattedDate } from 'utils/formatters'

import NoData from 'components/NoData'
import { selectCurrentBusiness } from 'store/business'
import BusinessZoneCount from 'components/BusinessZoneCount'
import messages from './messages'
import styles from './BusinessSummary.scss'

const sections = {
  details: ['businessType', 'incorpDate', 'firstActivityDate'],
  count: ['employees', 'location'],
  income: ['reported', 'estimated', 'documentedIncome'],
}

function BusinessSummary({ intl, isSpaced = true }) {
  const currentBusiness = useSelector(selectCurrentBusiness)

  const renderContent = field => {
    if (field === 'location') {
      return <BusinessZoneCount key={field} type='location' counts={currentBusiness.listings} />
    }
    if (field === 'employees') {
      return <BusinessZoneCount key={field} type='employee' counts={currentBusiness.employees} />
    }

    if (field === 'firstActivityDate')
      return (
        <span>
          {currentBusiness.firstActivityDate ? (
            formattedDate(currentBusiness.firstActivityDate, 'MMM DD, YYYY')
          ) : (
            <NoData />
          )}
        </span>
      )

    if (field === 'incorpDate')
      return (
        <span>
          {currentBusiness.incorpDate ? formattedDate(currentBusiness.incorpDate, 'MMM DD, YYYY') : <NoData />}
        </span>
      )

    if (field === 'documentedIncome') {
      if (currentBusiness.documentedIncome === -1) return <span>Out of State</span>
      return <Income value={currentBusiness.documentedIncome} />
    }

    const value = currentBusiness[field]
    return value ? <Tooltip title={value}>{value}</Tooltip> : <NoData />
  }

  return (
    <div className={styles.container}>
      <section className={styles.section}>
        {Object.keys(sections).map(key => (
          <Fragment key={key}>
            {sections[key].map(field => (
              <TitledContent
                key={`${key}|${field}`}
                title={intl.formatMessage(messages.fields[field])}
                className={cx(styles.field, styles[key])}
                titleClassName={styles.fieldTitle}
                contentClassName={cx(styles.fieldContent, styles[field])}
              >
                {renderContent(field)}
              </TitledContent>
            ))}
            {key !== 'income' && <span className={styles.separator} />}
          </Fragment>
        ))}
      </section>
    </div>
  )
}

BusinessSummary.propTypes = {
  intl: PropTypes.object.isRequired,
  isSpaced: PropTypes.bool,
}

export default injectIntl(BusinessSummary)
